import classNames from 'classnames';
import React from 'react';
import Flag from 'react-world-flags';
import { IDirectoryEntry } from 'services/CrmApi/types/DirectoryEntry';
import { useResponsive } from 'containers/CRM/hooks/useResponsive';
import { ContactLogo } from 'ui/ContactLogo';
import { isContactProfile } from 'containers/CRM/helpers';
import { ContactPageTitleRightPart } from './ContactPageTitleRightPart';


export interface IContactPageTitleProps {
  contactType: string;
  primaryClassName?: string;
  directoryEntry?: IDirectoryEntry;
}

export const ContactPageTitle: React.FC<IContactPageTitleProps> = ({ 
  contactType, primaryClassName = '', directoryEntry,
}) => {
  const { isDesktop, isDesktopHD } = useResponsive();
  if (!directoryEntry?.profile || !isContactProfile(directoryEntry?.profile)) {
    return null;
  }

  return (
    <div className="contact-page-title flex justify-between items-center">
      <div className="font-noe-display flex items-center gap-[10px]">
        <span className="contact-logo w-[60px] h-auto">
          <ContactLogo type="big" uuid={directoryEntry?.id} firstName={directoryEntry?.profile.firstName} lastName={directoryEntry?.profile.lastName}/>
        </span>
        <div className="flex flex-col ">
          <div className="flex gap-[10px] items-baseline">
            <h1 className={classNames('primary-title font-noe-display text-[26px] leading-normal max-w-[70vw] text-black font-normal m-0 text-ellipsis overflow-hidden whitespace-nowrap', primaryClassName)}>
              {directoryEntry?.fullName ?? ''}
            </h1>
            {directoryEntry?.country?.code && <Flag code={directoryEntry?.country?.code} className="relative top-[2px] w-[18px] h-[18px]" />}
          </div>
          <p className="font-pt-sans text-[15px] text-black m-0">{contactType}</p>
        </div>
      </div>
      {(isDesktop || isDesktopHD) && (
        <ContactPageTitleRightPart directoryEntry={directoryEntry} />
      )}
    </div>
  );
}
